'use client';

import React from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { Clock, TrendingDown, TrendingUp, Plus, Eye, ArrowRight } from 'lucide-react';

const PriceTrendChart = dynamic(() => import('./PriceTrendChart'), { ssr: false });


const ACTIVITIES = [
  { id: 'act-001', type: 'new', text: 'Kadıköy\'de yeni 3+1 ilan eklendi', sub: '₺9.750.000 · 148m²', time: '3 dk önce', color: 'text-success', bg: 'bg-success-light', icon: <Plus size={14} /> },
  { id: 'act-002', type: 'price_drop', text: 'Bodrum Yalıkavak villa fiyatı düştü', sub: '₺28.5M → ₺26.9M (-%5.6)', time: '12 dk önce', color: 'text-danger', bg: 'bg-danger-light', icon: <TrendingDown size={14} /> },
  { id: 'act-003', type: 'view', text: 'Antalya Konyaaltı ilanı 1.200 görüntüleme aldı', sub: 'Öne Çıkan · %7.2 getiri', time: '28 dk önce', color: 'text-primary', bg: 'bg-primary-light', icon: <Eye size={14} /> },
  { id: 'act-004', type: 'new', text: 'İzmir Alaçatı\'da butik villa projesi eklendi', sub: '₺7.200.000 · 80m²', time: '45 dk önce', color: 'text-success', bg: 'bg-success-light', icon: <Plus size={14} /> },
  { id: 'act-005', type: 'price_up', text: 'Muğla Bodrum m² fiyatı güncellendi', sub: '₺118.400 → ₺124.800 (+%5.4)', time: '1 sa önce', color: 'text-warning', bg: 'bg-warning-light', icon: <TrendingUp size={14} /> },
  { id: 'act-006', type: 'new', text: 'Bursa Nilüfer\'de 4+1 müstakil ev eklendi', sub: '₺8.900.000 · 180m²', time: '1 sa 20 dk önce', color: 'text-success', bg: 'bg-success-light', icon: <Plus size={14} /> },
  { id: 'act-007', type: 'price_drop', text: 'Ankara Çankaya rezidans fiyatı düştü', sub: '₺6.500.000 → ₺6.200.000 (-%4.6)', time: '2 sa önce', color: 'text-danger', bg: 'bg-danger-light', icon: <TrendingDown size={14} /> },
  { id: 'act-008', type: 'view', text: 'İstanbul Beşiktaş 1+1 kiralık trend oldu', sub: '5.600+ görüntüleme bugün', time: '3 sa önce', color: 'text-primary', bg: 'bg-primary-light', icon: <Eye size={14} /> },
];

export default function RecentActivity() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="section-label mb-1">Canlı Aktivite</p>
                <h2 className="text-display font-bold text-foreground">Son Gelişmeler</h2>
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <div className="w-2 h-2 rounded-full bg-success animate-pulse-soft"></div>
                <span>Canlı</span>
              </div>
            </div>

            <div className="space-y-2">
              {ACTIVITIES?.map((activity) => (
                <div key={activity?.id} className="flex items-start gap-3 p-3 rounded-xl hover:bg-muted transition-colors">
                  <div className={`w-7 h-7 rounded-lg ${activity?.bg} ${activity?.color} flex items-center justify-center flex-shrink-0`}>
                    {activity?.icon}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-foreground">{activity?.text}</p>
                    <p className="text-xs text-muted-foreground mt-0.5">{activity?.sub}</p>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-muted-foreground flex-shrink-0">
                    <Clock size={11} />
                    <span>{activity?.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Price Trend Chart */}
          <div>
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="section-label mb-1">Fiyat Trendi</p>
                <h2 className="text-display font-bold text-foreground">İstanbul m² Fiyat Değişimi</h2>
              </div>
              <Link href="/property-search" className="flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline">
                Detaylı Analiz <ArrowRight size={14} />
              </Link>
            </div>
            <div className="card-elevated rounded-2xl p-6">
              <PriceTrendChartWrapper />
              <p className="text-xs text-muted-foreground mt-4 text-center">Son 12 ay · Tahmin niteliğindedir · Kaynak: Evora Piyasa Analizi</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function PriceTrendChartWrapper() {
  return <PriceTrendChart />;
}